import type { CenterProps } from '@hover/blueprint';
import { Center, Image as SystemImage } from '@hover/blueprint';
import React from 'react';

import { useAltTextForImage } from 'src/modules/homeownerApp/hooks';
import type {
  AiDisplayImageFragment,
  AiGeneratedImageFragment,
} from 'src/shared/graphql/generated';

export type AiGeneratedImageWithWatermark = AiGeneratedImageFragment & {
  watermarkImageUrl?: string | null;
};
type AiDisplayImageWithWatermark = AiDisplayImageFragment & {
  aiGeneratedImage: AiGeneratedImageWithWatermark;
};

interface ImageProps extends CenterProps {
  image?: AiDisplayImageWithWatermark;
  imagePath?: string;
  altText?: string;
}

export const Image = ({
  image,
  imagePath,
  altText = '',
  ...props
}: ImageProps) => {
  const alt = useAltTextForImage(image);
  if (!image && !imagePath) return null;

  const { generatedImagePath, watermarkImageUrl } =
    image?.aiGeneratedImage || {};

  return (
    <Center
      borderRadius={400}
      maxWidth={{ tablet: '460px' }}
      overflow="hidden"
      sx={{ aspectRatio: '460 / 600' }}
      width="100%"
      {...props}
    >
      <SystemImage
        alt={altText ?? alt}
        height="100%"
        objectFit="cover"
        src={watermarkImageUrl ?? imagePath ?? generatedImagePath}
        width="100%"
      />
    </Center>
  );
};
